'use strict';

// ONLY USED FOR ADDING ORG OWNERS
import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Form } from 'react-bootstrap';
const uuid = require('uuid');

const Globals = require('../../../../app/globals');
const ValidateUtil = require('../../util/ValidateUtil');
const KeyboardUtil = require('../../util/keyboard');
const OrganizationActions = require('../../actions/OrganizationActions');
const OrganizationMemberStore = require('../../stores/OrganizationMemberStore');
import ErrorBox from '../common/ErrorBox';

const propTypes = {
    closeHandler: PropTypes.func.isRequired,
    show: PropTypes.bool,
    orgId: PropTypes.number.isRequired,
};

const defaultProps = {
    show: false,
};

class AdminAddOrgOwnerModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            organizationMemberStoreState: OrganizationMemberStore.getState(),
            memberEmail: "",
            actionID: null,
            ...ValidateUtil.getDefaultValidationState(),
        };

        this.submitHandler = this.submitHandler.bind(this);
        this.onEmailChange = this.onEmailChange.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.unsubscribes = [
            OrganizationMemberStore.listen(this.onOrganizationMemberStoreChange.bind(this))
        ];
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onOrganizationMemberStoreChange(state) {
        if (
            state.action.id === this.state.actionID
            && !state.action.error
        ) {
            this.props.closeHandler();
            return;
        }

        const additionalState = ValidateUtil.getUpdatedState(this.state.actionID, state);
        this.setState({ organizationMemberStoreState: state, ...additionalState });
    }

    submitHandler(projectName) {
        if (!!this.state.actionID) {
            return;
        }

        var actionID = uuid.v4();
        this.setState({ actionID: actionID }, () => {
            OrganizationActions.setOrganizationPermission(actionID, {
                orgId: this.props.orgId,
                email: this.state.memberEmail,
                role: Globals.users.roles.ORG_OWNER,
            });
        });
    }

    onEmailChange(e) {
        this.setState({ memberEmail: e.target.value });
    }

    handleKeyDown(e) {
        if (KeyboardUtil.isEnterKey(e.keyCode)) {
            this.submitHandler();
        }
    }

    render() {
        return (
            <Modal
                className='single-input-modal'
                show={this.props.show}
                enforceFocus={false}
                backdrop={false}
                animation={false}
                keyboard
                onHide={this.props.closeHandler}
            >
                <Modal.Header closeButton onHide={this.props.closeHandler}>
                    <Modal.Title>add organization owner</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <ErrorBox error={this.state.error} />
                    <Form>
                        <Form.Group controlId="modal-input-admin-add-owner">
                            <Form.Label>email address</Form.Label>
                            <Form.Control
                                value={this.state.memberEmail}
                                onChange={this.onEmailChange}
                                onKeyDown={this.handleKeyDown}
                                isInvalid={ValidateUtil.isInvalid(this.state, 'email')}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        disabled={!!this.state.actionID}
                        onClick={this.submitHandler}
                    >
                        add
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

AdminAddOrgOwnerModal.propTypes = propTypes;
AdminAddOrgOwnerModal.defaultProps = defaultProps;

export default AdminAddOrgOwnerModal;